import { Box } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { enrolledPath } from "@outschool/routes";
import { DismissibleAlert } from "@outschool/ui-components-website";
import { Container, Link } from "@outschool/ui-legacy-component-library";
import React from "react";
import { useLocation } from "react-router-dom";

export default function EnrolledLearnerSuccessBanner() {
  const { t } = useTranslation(
    "client\\components\\loggedInHome\\Dashboard\\EnrolledLearnerSuccessBanner",
  );
  const location = useLocation();
  const confirmedEnrollments =
    (location.state as any)?.confirmedEnrollments || [];
  const activity = (location.state as any)?.activity;
  if (!confirmedEnrollments || !activity) {
    return null;
  }
  return confirmedEnrollments.map(
    (enrollment: {
      uid: string;
      details: { name: string };
      section_uid: any;
    }) => (
      <Container size="medium" sx={{ width: "100%" }} key={enrollment.uid}>
        <DismissibleAlert
          id={"enrolled-learner-success-banner"}
          dismissible
          muteAfterXDismisses={1}
          severity="success"
          title={t('{{learnerName}} is now enrolled in "{{activityName}}"', {
            learnerName: enrollment.details?.name,
            activityName: activity.title,
          })}
          sx={{ width: "100%", marginTop: "2.4rem" }}
        >
          <Box>
            <Link
              to={enrolledPath(enrollment.section_uid)}
              style={{
                fontWeight: 500,
                color: "inherit",
              }}
            >
              {t("Visit Classroom")}&nbsp;
            </Link>
            {t(
              "to get started, and feel free to message the teacher if you have any learner details to share.",
            )}
          </Box>
        </DismissibleAlert>
      </Container>
    ),
  );
}
